import { render } from "./SimpleList.vue?vue&type=template&id=a1ee62b4&scoped=true"
import script from "./SimpleList.vue?vue&type=script&lang=js"
export * from "./SimpleList.vue?vue&type=script&lang=js"

import "./SimpleList.vue?vue&type=style&index=0&id=a1ee62b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ee62b4"]])

export default __exports__